import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { CurrentSizeDialogPageRoutingModule } from './current-size-dialog-routing.module';

import { CurrentSizeDialogPage } from './current-size-dialog.page';

import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    CurrentSizeDialogPageRoutingModule
  ],
  declarations: [CurrentSizeDialogPage]
})
export class CurrentSizeDialogPageModule {}
